import React from 'react';
import ArrayInput from './ArrayInput';

const BenefitsCertificationsSection = ({
  jobData,
  newBenefit,
  setNewBenefit,
  newCertification,
  setNewCertification,
  handleBenefitAdd,
  handleBenefitRemove,
  handleCertificationAdd,
  handleCertificationRemove
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Benefits & Certifications</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ArrayInput
          label="Benefits"
          arrayName="benefits"
          items={jobData.benefits}
          newValue={newBenefit}
          onValueChange={setNewBenefit}
          onAdd={handleBenefitAdd}
          onRemove={handleBenefitRemove}
          placeholder="Add a benefit..."
        />

        <ArrayInput
          label="Required Certifications"
          arrayName="certifications_required"
          items={jobData.certifications_required}
          newValue={newCertification}
          onValueChange={setNewCertification}
          onAdd={handleCertificationAdd}
          onRemove={handleCertificationRemove}
          placeholder="Add a certification..."
        />
      </div>
    </div>
  );
};

export default BenefitsCertificationsSection;